var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adminWrap"},[_c('div',{staticClass:"mb-5"},[_c('Boardsettings')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }